import MedicineList from './MedicineList';
import MedDash from "./MedDash";
const Medicines = () => {
    return(
    <>
    <MedDash/>
        <MedicineList/>
    </>
)
}
 export default Medicines;


